<template>
  <ValidationObserver v-slot="{ handleSubmit }" tag="div">
    <b-alert
      :show="authenticationErrorCode"
      variant="danger"
      dismissible
      fade
      >{{ authenticationError }}</b-alert
    >
    <form @submit.prevent="handleSubmit(onSubmit)">
      <b-form-group>
        <ValidationProvider
          name="email"
          rules="required|email"
          v-slot="{ errors }"
        >
          <b-form-input
            v-model="form.email"
            type="text"
            placeholder="Email"
            name="email"
            v-bind:readonly="isLodading"
          ></b-form-input>
          <span class="feedback feedback-invalid">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-form-group>
      <b-form-group>
        <ValidationProvider
          name="password"
          rules="required"
          v-slot="{ errors }"
        >
          <b-form-input
            v-model="form.password"
            type="password"
            placeholder="Hasło"
            v-bind:readonly="isLodading"
          ></b-form-input>
          <span class="feedback feedback-invalid">{{ errors[0] }}</span>
        </ValidationProvider>
      </b-form-group>
      <div class="login-rem_for">
        <b-form-checkbox
          v-model="form.remember"
          name="remember"
          :disabled="isLodading"
          >Zapamiętaj mnie</b-form-checkbox
        >
        <a href="#">Przypomnij hasło</a>
      </div>
      <div>
        <b-button
          variant="primary"
          block
          type="submit"
          v-bind:disabled="isLodading"
        >
          <b-spinner small v-show="isLodading"></b-spinner>Zaloguj się
        </b-button>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      isLodading: false,
      form: {
        remember: false,
        email: "",
        passowrd: "",
      },
    };
  },
  computed: {
    ...mapGetters("user", [
      "authenticating",
      "authenticationError",
      "authenticationErrorCode",
      "getRole",
    ]),
    ...mapGetters("app", ["setupLoaded"]),
  },
  methods: {
    ...mapActions("user", ["login", "load"]),
    ...mapActions("app", ["loadSetup"]),
    ...mapActions("company", ["getCompanies"]),
    onSubmit() {
      this.isLodading = true;
      this.$Progress.start();
      this.login(this.form).then((response) => {
        this.isLodading = false;
        if (response === true) {
          this.load().then(() => {
            this.getCompanies().then(() => {
              this.loadSetup(this.getRole);
              this.$store.commit("lastapimessage/displayed");
            });
          });
        }
      });
    },
  },
};
</script>